import { render } from "./Default.vue?vue&type=template&id=519c8ca5&scoped=true&ts=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"

import "./Default.vue?vue&type=style&index=0&id=519c8ca5&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519c8ca5"]])

export default __exports__